import React from "react";
import SelectInput from "common/SelectInput";
import PasswordInput from "common/PasswordInput";

const uispBillingSubscribers = [
  { label: "Leave unchanged", value: "unchanged" },
  { label: "Customer ID", value: "customer-id" },
  { label: "Name", value: "name" },
  { label: "Name + Customer ID", value: "name-customer-id" },
  { label: "Login", value: "login" },
];

const UISPBillingSettings = ({ onChange, defaults = {}, state }) => (
  <>
    <PasswordInput
      defaultValue={defaults.apikey}
      className="input-group"
      name="apikey"
      label="CRM API key"
      onChange={onChange}
    />
    <PasswordInput
      defaultValue={defaults["key-nms"]}
      className="input-group"
      name="key-nms"
      label="NMS API key"
      onChange={onChange}
    />
    <SelectInput
      label="Subscriber-ID source"
      name="subscriberIdSource"
      className="input-group"
      onChange={onChange}
      defaultValue={defaults.subscriberIdSource || "name"}
      options={uispBillingSubscribers}
    />
  </>);

export default UISPBillingSettings;
